exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-card {\n  max-width: 960px;\n  margin: 24px auto;\n  padding: 0;\n}\n\n.home-card-title {\n  padding: 12px 24px;\n}\n\n.pickup-table {\n  font-size: 1.3em;\n  border-top: 1px solid rgba(0, 0, 0, 0.24);\n  box-shadow: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = 206
// module chunks = 1